import { render, staticRenderFns } from "./MailFormActions.vue?vue&type=template&id=8b3094a0&scoped=true&"
import script from "./MailFormActions.vue?vue&type=script&lang=js&"
export * from "./MailFormActions.vue?vue&type=script&lang=js&"
import style0 from "./MailFormActions.vue?vue&type=style&index=0&id=8b3094a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3094a0",
  null
  
)

export default component.exports